import React, {useState} from 'react';
import styles from './styles.module.scss';
import {DialogRoot, Skeleton} from '@chakra-ui/react';
import classNames from 'classnames';
import {ReactComponent as PlayIcon} from 'svg/play-icon.svg';
import {IOfferItem} from 'types/offers';
import {FaArrowRight} from 'react-icons/fa6';
import DeviceTypeIcon from 'components/device-type-icon';
import {ReactComponent as CashIcon} from 'svg/coins.svg';
import Dialog from 'components/dialog';
import Details from './details';

const EarnCard: React.FC<{data: IOfferItem | null; loading: boolean}> = ({data, loading}) => {
  const [isOpen, setOpen] = useState(false);
  
  const handleCardClick = () => {
    setOpen(true);
  };

  return (
    <DialogRoot
      unmountOnExit={true}
      scrollBehavior="inside"
      size="lg"
      open={isOpen}
      onOpenChange={(details: {open: boolean}) => {
        setOpen(details.open);
      }}
      placement="center"
    >
      <div className={styles.wrapper} onClick={handleCardClick} style={{cursor: 'pointer'}}>
        <div className={styles.image}>
          {loading ? (
            <Skeleton height="100%" width="100%" className={classNames(styles.skeleton, styles.absolute)} />
          ) : (
            <>
              <img src={data?.game_logo} alt={data?.game_name} />
              <DeviceTypeIcon deviceType={data?.platform} />
              <div className={styles.hover}>
                <div className={styles.play}>
                  <PlayIcon />
                </div>
                <div className={styles.playText}>Offer Info</div>
              </div>
            </>
          )}
        </div>
        <div className={styles.title}>
          {loading ? <Skeleton height="21px" width="100%" className={styles.skeleton} /> : data?.game_name}
        </div>
        <div className={styles.row}>
          {loading ? (
            <Skeleton height="16px" width="50%" className={styles.skeleton} />
          ) : (
            <div className={styles.tag}>
              <div className={styles.green}>
                <CashIcon />
              </div>
              {data?.total_rewards_value_str}
            </div>
          )}
          <div className={classNames(styles.green, styles.btn)}>
            <FaArrowRight />
          </div>
        </div>
      </div>
      {isOpen && data?.offer_id ? (
        <Dialog isOpen={isOpen}>
          <Details itemId={data?.offer_id} />
        </Dialog>
      ) : null}
    </DialogRoot>
  );
};

export default EarnCard;
